import { toast } from '@/components/toasts/toast.helpers'

import { fetchingAPI, apiService } from '../../api'
import { setOrganizations } from './organizations.redux'

export const fetchOrganizations = () => async (dispatch) => {
  try {
    const organizations = await fetchingAPI(`${apiService.core}/api/organizations`, 'GET', dispatch)

    dispatch(setOrganizations(organizations))
  } catch (err) {
    // catching error
  }
}

export const createOrganization =
  ({ name, push, ringcentral_customer }) =>
  async (dispatch) => {
    try {
      const organization = await fetchingAPI(
        `${apiService.core}/api/organizations`,
        'POST',
        dispatch,
        JSON.stringify({ name, ringcentral_customer })
      )

      dispatch(fetchOrganizations())

      push(`/organizations/${organization.id}`)
    } catch (err) {
      toast.error(`Failed to create organization. ${err?.error_message}`, { cause: err })
    }
  }

// Whether the current user may edit the sensitive org security settings
// (unredacted / PCI compliance / SSN redaction). The allowlist lives in
// core-service, so we ask it rather than duplicate the list on the FE.
export const fetchSecuritySettingsAccess = (setCanManage) => async (dispatch) => {
  try {
    const res = await fetchingAPI(
      `${apiService.core}/api/organizations/security_settings/access`,
      'GET',
      dispatch
    )
    if (setCanManage) {
      setCanManage(Boolean(res?.can_manage))
    }
  } catch (err) {
    // Non-fatal: default to no access if the check fails.
    if (setCanManage) {
      setCanManage(false)
    }
  }
}

export const updateSecuritySettings =
  ({ organizationId, settings, onSuccess, onError }) =>
  async (dispatch) => {
    try {
      await fetchingAPI(
        `${apiService.core}/api/organizations/${organizationId}/security_settings`,
        'PATCH',
        dispatch,
        JSON.stringify(settings)
      )
      toast.success('Security settings updated successfully!')
      dispatch(fetchOrganizations())
      if (onSuccess) {
        onSuccess()
      }
    } catch (err) {
      // core-service returns { error: <message> } on a 400 (e.g. enabling SSN
      // redaction without PCI compliance), so surface that to the user.
      toast.error(err?.error || err?.message || 'Failed to update security settings.')
      if (onError) {
        onError()
      }
    }
  }
